import React from 'react';

import Loader from './components/Loader';
import Header from './components/Header';
import Body from './components/Body';
import Footer from './components/Footer';

import './components/utils/SpecialUtils';
import KeyboardDriver from './components/keyboard-driver/KeyboardDriver';

class GUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: props.isLoading,
      // Avatar
      avatar_shape: props.avatar_shape,
      // Content variables
      logo: props.logo,
      brand_name: props.brand_name,
      tagline: props.tagline,
      // Keywords
      keywords: props.keywords,
      // Progress
      progress: props.progress,
      // Test
      test: props.test,
      // Branding
      branding: props.branding,
      // General settings
      typing: props.typing,
      widget_hide_header: props.widget_hide_header,
    };
    this.ee = props.ee;

    // Keyboard shortcuts interface
    this.keyboardDriver = new KeyboardDriver({
      ee: this.ee,
    });
  }

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);
  }

  render() {
    const ee = this.ee;
    const { 
      isLoading,
      avatar_shape,
      logo,
      brand_name,
      tagline,
      keywords,
      persistent_menu,
      progress,
      test,
      branding,
      typing,
      widget_hide_header,
    } = this.props;
    const isMobile = this.isMobile();
    window.isMobile = isMobile;

    return (
      <div id="gui" ref={(elem) => this.guiRef = elem}>
        <Loader
          isLoading={isLoading}
        />
        <Header
          logo={logo}
          brand_name={brand_name}
          tagline={tagline}
          test={test}
          keywords={keywords}
          persistent_menu={persistent_menu}
          branding={branding}
          widget_hide_header={widget_hide_header}
          ee={ee}
        />
        <Body
          isMobile={isMobile}
          avatar_shape={avatar_shape}
          logo={logo}
          brand_name={brand_name}
          tagline={tagline}
          keywords={keywords}
          progress={progress}
          branding={branding}
          typing={typing}
          widget_hide_header={widget_hide_header}
          ee={ee}
        />
        <Footer
          brand_name={brand_name}
          keywords={keywords}
          branding={branding}
          typing={typing}
          ee={ee}
        />
      </div> 
    );
  }
}

export default GUI;


// WEBPACK FOOTER //
// ./app/js/GUI.js